import { capitalize } from "../../utils/capitalize";

// Coloured pill showing a grant's display status ("active" | "unclaimed" |
// "expired"). Styling (.statusBadge / .status-<status>) lives in Account.css,
// loaded by the account screen that renders this.
export default function StatusBadge({ status }) {
  return (
    <span className={`statusBadge status-${status}`}>{capitalize(status)}</span>
  );
}
